export default {"src":"/_next/static/media/icon-coinbase.5179903b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};